import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import DOMPurify from 'dompurify';
import LoadingDataSpinner from "@/components/Frontend/LoadingDataSpinner";
import { URLS } from "@/utils/urls";

const AboutUs = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState<string>('');
    const [content, setContent] = useState<string>('');

    useEffect(() => {
        fetchAboutUs();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchAboutUs = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(URLS?.aboutUs(1), {
                headers: { "Content-Type": "application/json" },
            });
            if (response.ok) {
                const data = await response.json();
                setTitle(data.title);
                setContent(data.content);
            } else {
                console.error("Failed to fetch data");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="py-[50px] px-[15px] sm:px-[10px] mx-[32px] sm:mx-0 flex flex-col gap-10">
            <h2 className="font-extrabold text-[30px] capitalize text-center text-[#555555]">
                About Us
            </h2>
            {isLoading ? (
                <LoadingDataSpinner />
            ) : (
                <div className="flex flex-row sm:flex-col mx-auto sm:gap-10 gap-20 max-w-[1200px]">
                    {/* Updated Image Container */}
                    <div className="flex justify-end  sm:items-center sm:mx-auto sm:w-full h-auto">
                        <Image
                            src="/images/about-us.jpg/"
                            alt="About us"
                            width={500}
                            height={0}
                            className="rounded-[30px] w-full sm:w-[300px] max-w-[500px] aspect-auto h-[245px] sm:h-auto object-cover"
                        />
                    </div>
                    {/* Content */}
                    <div className="flex-1 flex flex-col gap-5 text-[#777777]">
                        <h2 className="text-[18px] font-bold">{title}</h2>
                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} className="text-[14px] leading-7"></p>
                    </div>
                </div>
            )}
            {/* Features Section */}
            <div className="grid grid-cols-4 sm:grid-cols-1 gap-8 mx-auto max-w-[1200px] cursor-pointer">
                {[
                    {
                        icon: "/icons/plane.svg",
                        title: "Free Shipping",
                        description: "Free shipping on all India orders or above $200",
                    },
                    {
                        icon: "/icons/mic.svg",
                        title: "24X7 Support",
                        description: "Contact us 24 hours a day, 7 days a week",
                    },
                    {
                        icon: "/icons/box.svg",
                        title: "3 Days Return",
                        description: "Simply return it within 3 days for an exchange",
                    },
                    {
                        icon: "/icons/card.svg",
                        title: "Payment Secure",
                        description: "Contact us 24 hours a day, 7 days a week",
                    },
                ].map((item, index) => (
                    <div
                        key={index}
                        className="flex flex-col gap-4 border border-[#f4f4f4] rounded-lg justify-center items-center bg-white text-[#777777] text-center text-[14px] font-light p-[30px] hover:shadow-lg min-h-[250px]"
                    >
                        <Image src={item.icon} alt={item.title} width={50} height={50} />
                        <h2 className="text-[#444444] font-bold text-[18px]">{item.title}</h2>
                        <p className="text-center">{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AboutUs;
